<ng-template #modalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Confirmation required</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(false)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body mb-10">
    <div [hidden]="!loading" class="spinner">
      <div class="sk-spinner sk-spinner-pulse"></div>
    </div>
    <form [formGroup]="form" class="pos-relative form">
      <p class="alert alert-warning">
        <i class="icon-warning"></i> We have sent you an email with a confirmation code.
      </p>
      <div class="form-group mb-20">
        <input [(ngModel)]="codeModel" formControlName="code" (keyup.enter)="onSubmit()" type="text" class="form-control code-input" placeholder="Code"
         >
        <input-errors [control]="form.controls.code" [service]="validationService"></input-errors>
      </div>
      <div class="text-center mb-10">
        <button type="submit" class="btn btn-primary" [disabled]="!form.valid || loading || resendLoading" (click)="onSubmit()" style="width: 150px">
          <ng-container *ngIf="!loading">Submit</ng-container>
          <i *ngIf="loading" class="icon icon-wait spin"></i>
        </button>
      </div>
      <div class="text-center">
        <button class="btn btn-link" *ngIf="resendTimeout" [disabled]="loading || !resendTimeout.isFinish()" (click)="$event.stopPropagation();onResend()">
          <ng-container *ngIf="!resendLoading">Resend email {{ resendTimeout.formatSeconds() }}</ng-container>
          <i *ngIf="resendLoading" class="icon icon-wait spin"></i>
        </button>
      </div>
    </form>
  </div>
</ng-template>
